<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>TDS Data <span class="badge">{{totalRecords }}</span></h4>
            </div>
            <div class="rightDiv">
                <button class="exportBTn" (click)="exportExcel()"> <span><img
                            src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
                    Export</button>
                <!-- <button class="addBTn" (click)="addNewHomePageVideo()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add Video</button> -->
            </div>
        </div>
        <div class="mainDivBody">
            <div class="date-filterDiv">
                <ul class="filtersList">
                    <li>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            placeholder="Select Field" optionLabel="label"></p-dropdown>
                    </li>
                    <li>
                        <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
                            placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
                    </li>
                    <li>
                        <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                            placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
                    </li>
                    <li>
                        <button (click)="loadUsers($event)" class="searchFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <button class="clearFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                            <span>Clear All</span>
                        </button>

                    </li>
                </ul>

            </div>
            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table class="p1-table-columns hide-columns" [scrollable]="true" scrollHeight="auto"
                        scrollDirection="both" #dt [value]="userlist" [paginator]="true" [rows]="10" [lazy]="true"
                        (onLazyLoad)="loadUsers($event)" [totalRecords]="totalRecords" [loading]="loading"
                        [rowsPerPageOptions]="paginationOption" paginatorPosition="bottom"
                        styleClass="p-datatable-gridlines p-datatable-striped">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th pSortableColumn="TDSSection" class="TDSSection">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        TDS Section
                                        <p-sortIcon field="TDSSection"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="permannentAccountNumber" class="permannentAccountNumberTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        PAN Number
                                        <p-sortIcon field="permannentAccountNumber"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="nameofDeductee" class="nameofDeducteeTd">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Name
                                        <p-sortIcon field="nameofDeductee"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="invoiceDate" class="invoiceDateTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Invoice Date
                                        <p-sortIcon field="invoiceDate"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="invoiceNo" class="invoiceNoTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Invoice No
                                        <p-sortIcon field="invoiceNo"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="dateOnWhichAmountPaid" class="dateOnWhichAmountPaidTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Date on which
                                        Amount Paid / Credited
                                        <p-sortIcon field="dateOnWhichAmountPaid"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="RateAtWithTDSDeducted" class="RateAtWithTDSDeductedTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Rate at which
                                        TDS Deducted
                                        <p-sortIcon field="RateAtWithTDSDeducted"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="grossAmountPayable" class="grossAmountPayableTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Gross Amount Payable
                                        <p-sortIcon field="grossAmountPayable"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="TDSDeductedAmount" class="TDSDeductedAmountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        TDS Deducted Amount
                                        <p-sortIcon field="TDSDeductedAmount"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="amountPaymentCredit" class="amountPaymentCreditTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Amount of Payment / Credit
                                        <p-sortIcon field="amountPaymentCredit"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="status" class="statusTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Status
                                        <p-sortIcon field="status"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="actionTD p-frozen-column"> 
                                        Action 
                                </th>
                            </tr>
                            <tr>
                                <th [ngSwitch]="TDSSection" class="TDSSection">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'TDSSection', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['TDSSection'] ? dt.filters['TDSSection'].value : ''" />
                                </th>
                                <th [ngSwitch]="permannentAccountNumber" class="permannentAccountNumberTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'permannentAccountNumber', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['permannentAccountNumber'] ? dt.filters['permannentAccountNumber'].value : ''" />
                                </th>
                                <th [ngSwitch]="nameofDeductee" class="nameofDeducteeTd">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'nameofDeductee', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['nameofDeductee'] ? dt.filters['nameofDeductee'].value : ''" />
                                </th>
                                <th [ngSwitch]="invoiceDate" class="invoiceDateTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'invoiceDate', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['invoiceDate'] ? dt.filters['invoiceDate'].value : ''" />
                                </th>
                                <th [ngSwitch]="invoiceNo" class="invoiceNoTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'invoiceNo', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['invoiceNo'] ? dt.filters['invoiceNo'].value : ''" />
                                </th>
                                <th [ngSwitch]="dateOnWhichAmountPaid" class="dateOnWhichAmountPaidTD">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'dateOnWhichAmountPaid', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['dateOnWhichAmountPaid'] ? dt.filters['dateOnWhichAmountPaid'].value : ''" />
                                </th>
                                <th [ngSwitch]="RateAtWithTDSDeducted" class="RateAtWithTDSDeductedTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'RateAtWithTDSDeducted', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['RateAtWithTDSDeducted'] ? dt.filters['RateAtWithTDSDeducted'].value : ''" />
                                </th>
                                <th [ngSwitch]="grossAmountPayable" class="grossAmountPayableTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'grossAmountPayable', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['grossAmountPayable'] ? dt.filters['grossAmountPayable'].value : ''" />
                                </th>
                                <th [ngSwitch]="TDSDeductedAmount" class="TDSDeductedAmountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'TDSDeductedAmount', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['TDSDeductedAmount'] ? dt.filters['TDSDeductedAmount'].value : ''" />
                                </th>
                                <th [ngSwitch]="amountPaymentCredit" class="amountPaymentCreditTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'amountPaymentCredit', 'contains')"
                                        style="width: 90px;"
                                        [value]="dt.filters['amountPaymentCredit'] ? dt.filters['amountPaymentCredit'].value : ''" />
                                </th>
                                <th [ngSwitch]="status" class="statusTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <p-dropdown #pDropDownId [options]="statuses" [style]="{'width':'100%'}"
                                        appendTo="body"
                                        (onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
                                        <ng-template let-option pTemplate="item">
                                            <span
                                                [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </th>
                                <th class="actionTD p-frozen-column">
                                    <div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-user>
                            <tr class="p-selectable-row">
                                <td class="TDSSection">
                                    {{user.fullName}}
                                </td>
                                <td class="permannentAccountNumberTD">
                                    {{user.email}}
                                </td>
                                <td class="nameofDeducteeTd">
                                    {{user.cityname}}
                                </td>
                                <td class="invoiceDateTD">
                                    {{user.statename}}
                                </td>
                                <td class="invoiceNoTD">
                                    {{user.countryname}}
                                </td>
                                <td class="dateOnWhichAmountPaidTD">

                                </td>
                                <td class="RateAtWithTDSDeductedTD">

                                </td>
                                <td class="grossAmountPayableTD" [ngClass]="hide ? 'hide-column' : 'show-column'">

                                </td>
                                <td class="TDSDeductedAmountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">

                                </td>
                                <td class="amountPaymentCreditTD" [ngClass]="hide ? 'hide-column' : 'show-column'">

                                </td>
                                <td class="col-width" [ngClass]="hide ? 'hide-column' : 'show-column'">

                                </td>
                                <td class="col-width" [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    {{user.updatedBy}}
                                </td>
                                <td class="statusTD " [ngClass]="hide ? 'hide-column' : 'show-column'">
                                    <span *ngIf="user.status">
                                        <p-tag styleClass="mr-2" severity="success" value="Active"></p-tag>
                                    </span>
                                    <span *ngIf="!user.status">
                                        <p-tag severity="danger" value="In-Active"></p-tag>
                                    </span>
                                    <p-inputSwitch [(ngModel)]="user.status"
                                        (onChange)="changeStatus(user)"></p-inputSwitch>
                                </td>
                                <td class="actionTD p-frozen-column">
                                    <button pButton pRipple icon="pi pi-eye"
                                        class="p-button-rounded p-button-success p-mr-2"
                                        (click)="viewAdmin(user.id)"></button>
                                    <button pButton pRipple icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success p-mr-2"
                                        (click)="editUser(user.id)"></button>
                                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                                        (click)="deleteUser(user)"></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="12">No TDS Data found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div> 

<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>